import React from 'react';
import styles from './side-bar.module.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useTranslation } from 'react-i18next';

export const SideBar: React.FC = () => {
  const { t } = useTranslation();
  const { organisation } = useSelector((state: RootState) => state.organization);
  return (
    <aside className={styles.sidebar}>
      <div className={styles.header}>
        <h1>{organisation?.name}</h1>
      </div>
      <nav className={styles.nav}>
        <ul>
          <li className={`${styles.navItem} ${styles.active}`}>
            <span className={styles.icon}>👥</span>{' '}
            <span className={styles.navText}>{t('clientOrganisation')}</span>
          </li>
        </ul>
      </nav>
    </aside>
  );
};
